import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { DsiAddress as Address } from '../Form/Address';
import { SubTitle } from './Favorites';
import { StyledInput } from '../Auth/WarehouseRegisterForm';
import { StyledLabel } from '../Auth/LoginForm';
import {
  Required,
  StyledCheckBoxWrapper,
  StyledRegister,
} from '../Auth/RegisterForm';
import { DsiCheckBox as CheckBox } from '../General/Checkbox';
import { StyledLabel as PrivacyLabel } from '../Category/ProductFilterItem';
import { Select } from '../General/Select';
import { FormInput } from '../Form/FormInput';

interface Props {
  name: string;
  surname: string;
  street: string;
  streetNumber: string;
  city: string;
  zip: string;
  country: string;
  isCompany: boolean;
  onChange: any;
  isB2B?: boolean;
  lang: string;
  problems?: any;
}

function InvoiceAddressBlock({
  name,
  surname,
  street,
  streetNumber,
  city,
  zip,
  country,
  isCompany,
  onChange,
  isB2B,
  lang,
  problems,
}: Props) {
  const {
    nameProblem,
    surnameProblem,
    streetProblem,
    streetNumberProblem,
    cityProblem,
    zipProblem,
  } = {
    nameProblem: problems?.person?.name,
    surnameProblem: problems?.person?.surname,
    streetProblem: problems?.street,
    streetNumberProblem: problems?.street_number,
    cityProblem: problems?.city,
    zipProblem: problems?.zip,
  };

  return (
    <Wrapper>
      <SubTitle>{`${__('Fakturačná adresa')}`}</SubTitle>
      <NameRow isB2B={isB2B}>
        {/* <StyledInput marginRight={16}> */}
        {(!!name || !isB2B) && (
          <FormInput
            justText={isB2B}
            required={true}
            name={'name'}
            type="text"
            label={!isB2B ? __('Meno') : __('Meno a priezvisko')}
            value={name}
            marginRight={0}
            onChange={onChange}
            maxWidthPx={336}
            marginBottom={16}
            validMessage={nameProblem}
          />
        )}
        {/* </StyledInput> */}
        {!isB2B && (
          <StyledInput>
            <FormInput
              name={'surname'}
              type="text"
              required={true}
              label={__('Priezvisko')}
              value={surname}
              marginBottom={0}
              onChange={onChange}
              validMessage={surnameProblem}
            />
          </StyledInput>
        )}
      </NameRow>
      <Address
        street={street}
        streetNumber={streetNumber}
        city={city}
        zip={zip}
        onChange={onChange}
        isB2B={isB2B}
        formProblems={{
          streetProblem,
          streetNumberProblem,
          cityProblem,
          zipProblem,
        }}
      />
      <StyledInput>
        <Select
          justText={isB2B}
          value={country}
          label={__('Krajina')}
          name="country"
          options={
            lang === 'cz'
              ? [{ value: 'cz', name: __('Česká republika') }]
              : [{ value: 'sk', name: 'Slovensko' }]
          }
          onChange={onChange}
          marginBottom={16}
          maxWidth={600}
          backgroundColor={'#FFFFFF'}
        />
      </StyledInput>
      {/* {!isB2B && (
        <StyledCheckBoxWrapper marginTop={16} marginBottom={32}>
          <CheckBox
            name={'isCompany'}
            type={'checkbox'}
            selected={isCompany}
            onClick={onChange}
          />
          <PrivacyLabel htmlFor={'privacy'} selected={isCompany}>
            {`${__('Nakupujem na firmu')}`}
          </PrivacyLabel>
        </StyledCheckBoxWrapper>
      )} */}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  margin-top: ${rem(40)};
`;

const NameRow = styled(FlexRowCenterVertical)<{ isB2B?: boolean }>`
  margin-bottom: ${({ isB2B }) => (isB2B ? 0 : rem(16))};
  gap: ${rem(16)};
`;

export { InvoiceAddressBlock as DsiInvoiceAddressBlock };
